import React from "react";
import { useSelector } from "react-redux";
import { FormatMoneyNumber } from "utils/numberUtils";
import { selectState } from "../accountPayable.slice";

const TableFooter = () => {
  const {
    payablesTotalInvoicedAmountForPartner,
    payablesTotalOutstandingAmountForPartner,
    payablesTotalPaidAmountForPartner,
    payablesTotalXxxInvoicedAmountForPartner,
    payablesTotalXxxOutstandingAmountForPartner,
    payablesTotalXxxPaidAmountForPartner,
    payablesTotalCashPaidAmountForPartner,
  } = useSelector(selectState);
  return (
    <table className="table-footer second-footer">
      <colgroup>
        <col className="w2" />
        <col className="w2" />
        <col className="w10" />
        <col className="w15" />
        <col className="w9" />
        <col className="w9" />
        <col className="w15" />
        <col className="w11" />
        <col className="w10" />
        <col className="w3" />
      </colgroup>
      <tfoot>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td className="right">
            <b>Ukupno:</b>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalInvoicedAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalOutstandingAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalPaidAmountForPartner)}
            </span>
          </td>
          <td />
          <td />
          <td />
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td className="right">
            <b>Ukupno xxx:</b>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalXxxInvoicedAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalXxxOutstandingAmountForPartner)}
            </span>
          </td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalXxxPaidAmountForPartner)}
            </span>
          </td>
          <td />
          <td />
          <td />
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td className="right">
            <b>Ukupno keš:</b>
          </td>
          <td></td>
          <td></td>
          <td>
            <span className="total-value">
              {FormatMoneyNumber(payablesTotalCashPaidAmountForPartner)}
            </span>
          </td>
          <td />
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  );
};

export default TableFooter;
